export const VIDEO_PREVIEW_VOLUME_STORAGE_KEY = "gvtui.videoPreview.volume";
export const VIDEO_PREVIEW_MUTED_STORAGE_KEY = "gvtui.videoPreview.muted";
export const VIDEO_PREVIEW_VOLUME_CHANGED_EVENT =
	"video_preview_volume_changed";
export const VIDEO_PREVIEW_PAUSE_ALL_EVENT = "video_preview_pause_all";

export type VideoPreviewVolumeChangedDetail = {
	originator: string;
	volume: number;
	muted: boolean;
};

const clampVolume = (volume: number) => Math.max(0, Math.min(1, volume));

export const readStoredVideoVolume = () => {
	try {
		const storedVolume = window.localStorage.getItem(
			VIDEO_PREVIEW_VOLUME_STORAGE_KEY,
		);
		if (storedVolume === null) return 1;
		const parsedVolume = Number(storedVolume);
		return Number.isFinite(parsedVolume) ? clampVolume(parsedVolume) : 1;
	} catch {
		return 1;
	}
};

export const readStoredVideoMuted = () => {
	if (!window?.localStorage.getItem(VIDEO_PREVIEW_MUTED_STORAGE_KEY))
		return false;
	return (
		window.localStorage.getItem(VIDEO_PREVIEW_MUTED_STORAGE_KEY) === "true"
	);
};

export const storeVideoPreviewVolume = (volume: number, muted: boolean) => {
	window.localStorage.setItem(
		VIDEO_PREVIEW_VOLUME_STORAGE_KEY,
		String(clampVolume(volume)),
	);
	window.localStorage.setItem(VIDEO_PREVIEW_MUTED_STORAGE_KEY, String(muted));
};

export function dispatchVideoPreviewVolumeChanged(
	detail: VideoPreviewVolumeChangedDetail,
): void {
	storeVideoPreviewVolume(detail.volume, detail.muted);
	document.dispatchEvent(
		new CustomEvent(VIDEO_PREVIEW_VOLUME_CHANGED_EVENT, { detail }),
	);
}

export function dispatchVideoPreviewPauseAll(): void {
	document.dispatchEvent(new CustomEvent(VIDEO_PREVIEW_PAUSE_ALL_EVENT));
}

let nextVideoPreviewOriginatorId = 0;

export function createVideoPreviewOriginatorId(): string {
	nextVideoPreviewOriginatorId += 1;
	return `video-preview-${nextVideoPreviewOriginatorId}`;
}
